import React from 'react';
import { useNavigate } from 'react-router-dom';

function PropertiesHub() {
  const navigate = useNavigate();

  return (
    <div className="admin-dashboard-container">
      {/* Header with Back Button */}
      <div className="admin-hub-header">
        <button
          onClick={() => navigate('/admin')}
          className="admin-hub-back-btn"
        >
          <span className="admin-hub-back-arrow">←</span>
          Back to Dashboard
        </button>
        <h1 className="admin-page-title">Properties</h1>
        <p className="admin-hub-subtitle">Manage your property listings and state availability</p>
      </div>

      {/* Hub Cards Grid */}
      <div className="admin-hub-grid">
        <div className="card admin-menu-card" onClick={() => navigate('/admin/properties')}>
          <div className="admin-hub-card-icon">🏘️</div>
          <h2>Property Management</h2>
          <p>Add, edit, and manage property listings. Upload images, set pricing, and track acquisition costs.</p>
          <button className="btn btn-primary">Manage Properties</button>
        </div>

        <div className="card admin-menu-card" onClick={() => navigate('/admin/states')}>
          <div className="admin-hub-card-icon">🗺️</div>
          <h2>State Management</h2>
          <p>Control which states are displayed on the public site. Enable or disable states as your inventory changes.</p>
          <button className="btn btn-primary">Manage States</button>
        </div>
      </div>
    </div>
  );
}

export default PropertiesHub;
